import {
	AppPage,
	AppsCatalog,
	CatalogMain,
	CatalogGenre,
	CatalogInstalled,
	CatalogNew,
	Main,
	CatalogPopular,
	PaymentResult,
} from '@pages';
import { renderRoutes, RouteConfig } from 'react-router-config';

import { ROUTES } from '@constants';

import { RouterSwitch } from '@components/RouterSwitch';

import { IRouteConfigComponent } from '@interfaces';

export const routes: IRouteConfigComponent[] = [
	{
		path: ROUTES.PAYMENT_RESULT,
		component: PaymentResult,
	},
	{
		path: ROUTES.APP,
		component: AppPage,
	},
	{
		path: ROUTES.CATALOG_NEW,
		component: CatalogNew,
	},
	{
		path: ROUTES.CATALOG_INSTALLED,
		component: CatalogInstalled,
	},
	{
		path: ROUTES.CATALOG_POPULAR,
		component: CatalogPopular,
	},
	{
		path: ROUTES.CATALOG,
		component: AppsCatalog,
		routes: [
			{
				path: ROUTES.CATALOG,
				component: CatalogMain,
				exact: true,
			},
			{
				path: ROUTES.CATALOG_GENRE,
				component: CatalogGenre,
			},
		],
	},
	{
		path: ROUTES.MAIN,
		component: Main,
		exact: true,
	},

];

export const popups: RouteConfig[] = [

];

// eslint-disable-next-line new-cap
export const Router = RouterSwitch(routes);

export const RouterPopups = () => {
	return renderRoutes(popups);
};
